/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsThreadChartColor,
    ControlcenterMelcoModelsThreadChartColorFromJSON,
    ControlcenterMelcoModelsThreadChartColorFromJSONTyped,
    ControlcenterMelcoModelsThreadChartColorToJSON,
    ControlcenterMelcoModelsThreadChartProduct,
    ControlcenterMelcoModelsThreadChartProductFromJSON,
    ControlcenterMelcoModelsThreadChartProductFromJSONTyped,
    ControlcenterMelcoModelsThreadChartProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsCreateThreadChart
 */
export interface ControlcenterMelcoModelsCreateThreadChart {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateThreadChart
     */
    file_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCreateThreadChart
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCreateThreadChart
     */
    publish_state?: number;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsThreadChartProduct>}
     * @memberof ControlcenterMelcoModelsCreateThreadChart
     */
    product_list?: Array<ControlcenterMelcoModelsThreadChartProduct> | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsThreadChartColor>}
     * @memberof ControlcenterMelcoModelsCreateThreadChart
     */
    thread_chart_color_list?: Array<ControlcenterMelcoModelsThreadChartColor> | null;
}

export function ControlcenterMelcoModelsCreateThreadChartFromJSON(json: any): ControlcenterMelcoModelsCreateThreadChart {
    return ControlcenterMelcoModelsCreateThreadChartFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsCreateThreadChartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsCreateThreadChart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(ControlcenterMelcoModelsThreadChartProductFromJSON)),
        'thread_chart_color_list': !exists(json, 'thread_chart_color_list') ? undefined : (json['thread_chart_color_list'] === null ? null : (json['thread_chart_color_list'] as Array<any>).map(ControlcenterMelcoModelsThreadChartColorFromJSON)),
    };
}

export function ControlcenterMelcoModelsCreateThreadChartToJSON(value?: ControlcenterMelcoModelsCreateThreadChart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.file_name,
        'version': value.version,
        'publish_state': value.publish_state,
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(ControlcenterMelcoModelsThreadChartProductToJSON)),
        'thread_chart_color_list': value.thread_chart_color_list === undefined ? undefined : (value.thread_chart_color_list === null ? null : (value.thread_chart_color_list as Array<any>).map(ControlcenterMelcoModelsThreadChartColorToJSON)),
    };
}


